import { StrategyFieldSet } from '@/App/Blotter/grids/option/details/StrategyFieldSet.tsx';
import { VanillaFieldSet } from '@/App/Blotter/grids/option/details/VanillaFieldSet.tsx';
import type { BlotterOptionEntry } from '@/store/blotter/types/BlotterOptionEntry.ts';

type Props = {
  entry: BlotterOptionEntry;
};

export const Fieldset = ({ entry }: Props) => {
  switch (entry.product) {
    case 'Vanilla':
      return <VanillaFieldSet entry={entry} />;
    case 'Strategy':
    case 'Straddle':
    case 'Strangle':
    case 'RiskReversal':
      return <StrategyFieldSet entry={entry} />;
  }

  return <div>Unhandled product type {entry.product}</div>;
};
